import { ApiModule, type PaginatedResponseData } from '@common/index';

export class LoginTransactionApi extends ApiModule {
  protected endpoint = '/transaction/login';

  public async pageLoginTransactions(params: any) {
    return this.api.post<PaginatedResponseData<any>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }
}
